import React from 'react';
import { OrderStatus } from '../../lib/types';

const TONE: Record<string, 'gray' | 'blue' | 'amber' | 'green'> = {
  Pending:   'gray',
  Ordered:   'blue',
  Delivered: 'amber',
  Closed:    'green',
};

interface StatusPillProps {
  status: OrderStatus | string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  withCaret?: boolean;
  compact?: boolean;
}

export function StatusPill({ status, onClick, withCaret, compact }: StatusPillProps) {
  const tone = TONE[status] || 'gray';
  const Tag: any = onClick ? 'button' : 'span';
  return (
    <Tag
      className={`pill-u ${tone}`}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        padding: compact ? '1px 8px' : undefined,
      }}
    >
      {status}
      {withCaret && (
        <svg viewBox="0 0 12 12" width="8" height="8" fill="currentColor" style={{ opacity: .55 }}>
          <path d="M2 4l4 4 4-4" />
        </svg>
      )}
    </Tag>
  );
}
